import script from "./modal.vue?vue&type=script&setup=true&lang=js"
export * from "./modal.vue?vue&type=script&setup=true&lang=js"

import "./modal.vue?vue&type=style&index=0&id=1e40843c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e40843c"]])

export default __exports__